import { Injectable } from '@angular/core';
import {
    HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private authenticationService: AuthenticationService,
        private toastr: ToastrService,
        private router: Router) { }



    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(tap(res => {
            if (res instanceof HttpResponse) {
                if (!res.body.success
                    && (res.body.code === 1000)) {
                    // this.toastService.warning(res.body.message);
                }
            }
        }), catchError((err: HttpErrorResponse) => {
            const isV2 = request.url.includes('/v2/');

            if (err.status === 401) {
                // Unauthorized User
                this.toastr.error(err.error?.error || err.statusText)
                this.authenticationService.logout()
            } else if (err.status === 403) {
                this.toastr.error(
                    err.error?.error
                    || err.error?.message
                    || "You don't have required permissions, Please contact your System Administrator in order to request permissions"
                )
            } else if (!isV2 && err.status === 500) {
                // Non-v2 only — v2 callers toast via BaseService + subscribe error.
                this.toastr.error(err.error?.error ?? err.statusText)
            } else if (!isV2 && err.status == 600) {
                //Invalid payload
                this.toastr.error('Invalid Payload')
            }
            // v2: keep HttpErrorResponse so BaseService can read BE error/message from the body.
            // Non-v2: keep master behaviour (plain Error with Angular HTTP text).
            if (isV2) {
                return throwError(() => err);
            }
            return throwError(() => new Error(err.message))
        }));
    }

    public reRouteToLoginPage(): void {
        this.authenticationService.logout();
        setTimeout(() => {
            this.router.navigate(['']);
        });
    }

}


